// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3rSjE","isSmall":"Loader_isSmall__x6W6B","loaderSmall":"Loader_loaderSmall__1SCrt"};